import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import InstallApp from "./pwa/InstallApp";
import {registerServiceWorker} from "./pwa/registerServiceWorker";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /><InstallApp /></React.StrictMode>);
registerServiceWorker();
